import type { Snapshot } from "../types";

// Fields serialised into the share URL. Excludes ts/id (history-only).
const KEYS: (keyof Snapshot)[] = [
  "style", "count", "unitWeight", "yeast", "sdMode", "starterHyd", "time",
  "temp", "yeastPct", "yeastManual", "hydration", "salt", "oil", "sugar", "butter",
];

function b64urlEncode(s: string): string {
  const bytes = new TextEncoder().encode(s);
  let bin = "";
  for (const b of bytes) bin += String.fromCharCode(b);
  return btoa(bin).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

function b64urlDecode(s: string): string {
  const b64 = s.replace(/-/g, "+").replace(/_/g, "/");
  const bytes = Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));
  return new TextDecoder().decode(bytes);
}

export function encodeState(s: Snapshot): string {
  const obj: Record<string, unknown> = {};
  for (const k of KEYS) obj[k] = s[k];
  return b64urlEncode(JSON.stringify(obj));
}

export function decodeState(hash: string): Snapshot | null {
  const raw = hash.startsWith("#") ? hash.slice(1) : hash;
  if (!raw) return null;
  try {
    const obj = JSON.parse(b64urlDecode(raw));
    if (!obj || typeof obj !== "object" || typeof obj.style !== "string") return null;
    return obj as Snapshot;
  } catch {
    return null;
  }
}
